// import { string } from "zod";
import { FunctionKeyShortcut } from "../data/arrays/FunctionKeyShortcut";
import { handleDropdownClick } from "../utils/functions/handleDropdownClick";

 
interface shortcut  {
  action :string,
  key : string,
  altKey? : boolean,
  ctrlKey?:boolean
}
type DropdownState = Record<string, boolean>;

// Correct type for setDropdownState
type SetDropdownState = React.Dispatch<React.SetStateAction<DropdownState>>;

export const handleAction = (action: string, setDropdownState: SetDropdownState): void => {
  switch (action) {
    case "isShortCutKey":
      handleDropdownClick(action, setDropdownState);
      break;
    case "/dashboard":
      window.location.replace("/dashboard");
      break;
    case "/sales/invoice/new":
      window.location.replace("/sales/invoice/new");
      break;
    case "/sales/estimate/new":
      window.location.replace("/sales/estimate/new");
      break;
    case "/purchase/bill/new":
      window.location.replace("/purchase/bill/new");
      break;
    case "/product/new":
      window.location.replace("/product/new");
      break;
    case "/pos/new":
      window.location.replace("/pos/new");
      break;
    case "/contact/new":
      window.location.replace("/contact/new");
      break;
    case "/payment/new":
      window.location.replace("/payment/new");
      break;
    case "/receipt/new":
      window.location.replace("/receipt/new");
      break;
    case "/product/opening-stock":
      window.location.replace("/product/opening-stock");
      break;
    case "saveData":  
      break;
    default:
      break;
  }
};
 
 export const useKeyboardShortcuts = (
  setDropdownState: SetDropdownState
): (() => void) => {
  const handleKeyPress = (event: KeyboardEvent): void => {
    // Check for Ctrl+S
    if (event.ctrlKey && event.code === "KeyS") {
      const saveShortcut = FunctionKeyShortcut.find(
        (shortcut: shortcut) => shortcut.key === "S" && shortcut?.ctrlKey
      );
      if (saveShortcut) {
        event.preventDefault();
        handleAction(saveShortcut.action, setDropdownState);
      }
      return;
    }

    // Check for Alt+C
    if (event.altKey && event.code === "KeyC") {
      const altCShortcut = FunctionKeyShortcut.find(
        (shortcut: shortcut) => shortcut.key === "C" && shortcut.altKey
      );
      if (altCShortcut) {
        event.preventDefault();
        handleAction(altCShortcut.action, setDropdownState);
      }
      return;
    }

    // Check for Alt+P
    if (event.altKey && event.code === "KeyP") {
      const altPShortcut = FunctionKeyShortcut.find(
        (shortcut: shortcut) => shortcut.key === "P" && shortcut?.altKey
      );
      if (altPShortcut) {
        event.preventDefault();
        handleAction(altPShortcut.action, setDropdownState);
      }
      return;
    }

    // General key handling
    const key = FunctionKeyShortcut.find((shortcut: shortcut) => {
      return (
        shortcut.key === event.key &&
        (!shortcut.altKey || event.altKey) &&
        (!shortcut.ctrlKey || event.ctrlKey)
      );
    });
    if (key) {
      event.preventDefault();
      handleAction(key.action, setDropdownState);
    }
  };

  document.addEventListener("keydown", handleKeyPress);

  return () => {
    document.removeEventListener("keydown", handleKeyPress);
  };
};

